"use client";

import { useState } from "react";

import { useRouterBack } from "@/shared-web.ui/hook.use-router-back";
import { PrimDialog } from "@/shared-web.ui/prim.dialog";

import { CategoryData, CategorySelector } from "../feat.category-selector/category-selector.ui";

interface ModalClientCategoryProps {
  categoryData: CategoryData;
}

export const ModalClientCategory = (props: ModalClientCategoryProps) => {
  const { categoryData } = props;

  const [open, setOpen] = useState(true);

  const { routerBack } = useRouterBack();

  return (
    <PrimDialog.Root
      open={open}
      onOpenChange={(v) => {
        routerBack();
        setOpen(v);
      }}
    >
      <PrimDialog.ContentMinStyled
        className="bg-panel-solid rounded-3"
      >
        <div className="h-[calc(100dvh-9rem)]">
          <CategorySelector
            data={categoryData}
            moduleType="Page"
          />
        </div>
      </PrimDialog.ContentMinStyled>
    </PrimDialog.Root>
  );
};
